import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { client } from "../sanityClient";

const SanityBlog = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "post" && slug.current == $slug][0]{
        title,
        publishedAt,
        "image": mainImage.asset->url,
        body
      }`,
        { slug }
      )
      .then((data) => {
        setPost(data);
      });
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <div style={{ padding: "40px" }}>
      <h1>{post.title}</h1>
      <p>{new Date(post.publishedAt).toDateString()}</p>
      <img src={post.image} alt={post.title} style={{ width: "100%" }} />
      <p>{post.body}</p>
    </div>
  );
};

export default SanityBlog;